import React from 'react';
import { CheckboxEmpty, CheckboxFilled } from '../../Buttons/IconButton/Icons';
const ThemedCheckbox = props => {
  return props.selected ? (
    <div className="sf-themed-checkbox">
      <CheckboxFilled />
    </div>
  ) : (
    <div className="sf-themed-checkbox">
      <CheckboxEmpty />
    </div>
  );
};
export default ThemedCheckbox;
